import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
const supply_chain_template_sharing = apiUrl + "/supply_chain_template_sharing";
const routes = {
  label: "SupplyChain Template Sharing",
  root: supply_chain_template_sharing,
  get_by_company_id: supply_chain_template_sharing + "/get_by_company_id",
  new: supply_chain_template_sharing + "/new",
  delete: supply_chain_template_sharing + "/delete",
};
export const SupplyChainTemplateSharing = {
  label: routes.label,
  get_by_company_id: (company_id) => getWithToken(routes.get_by_company_id, { company_id }),
  /**
   *
   * @param {[{company_id: number, supply_chain_id: string}]} supply_chain_template_sharings
   * @returns
   */
  new: (supply_chain_template_sharings) => postWithToken(routes.new, supply_chain_template_sharings),
  /**
   *
   * @param {[{company_id: number, supply_chain_id: string}]} supply_chain_template_sharings
   * @returns
   */
  delete: (supply_chain_template_sharings) => postWithToken(routes.delete, supply_chain_template_sharings),
};
